import type React from 'react';
import { useNavigate } from 'react-router';
import settings from '/@/core/settings';
import { reverse } from '/@/utils/router';

interface LinkProps {
    to: string;
    qs?: Record<string, any>;
    params?: Record<string, any>;
    disabled?: boolean;
    className?: string;
    blank?: boolean;
}

const Link: React.FC<LinkProps> = ({
    to,
    qs = {},
    params = {},
    disabled = false,
    className = '',
    blank = false,
    children,
}) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (!disabled) {
            const url = reverse(to, { qs, params });

            if (blank) return window.open(`${settings.app.url}${url}`);
            return navigate(url);
        }
    };

    return (
        <div className={className} onClick={handleClick}>
            {children}
        </div>
    );
};

export default Link;
